import { useEffect, useRef } from "react";
import classNames from "classnames";

import styles from "./uploadFile.module.css";

import { Text } from "../text/text";

export const UploadFile = ({ placeholder = "Выберите файл", selectedFile, setSelectedFile, view = "normal", ...props }) => {
    const ref = useRef(null);

    useEffect(() => {
        if (selectedFile === null && ref.current) {
            ref.current.value = "";
        }
    }, [selectedFile]);

    return (
        <label className={classNames(styles.upload_button, { [styles.selected]: !!selectedFile }, styles[view])}>
            <input type="file" ref={ref} className={styles.file_input} onChange={(e) => setSelectedFile(e.target.files[0])} {...props} />
            <Text as="div" variant="body" className={styles.input_text} size={14} weight={700} lineHeight="1.1">{selectedFile ? selectedFile.name : placeholder}</Text>
        </label>
    )
}
